import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import { Link, useHistory } from "react-router-dom";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import ShareDialog from "../../../../components/ShareDialog";
import { getPropertyUnits } from "../../../../services/units";
import "./styles.css";

function Units(props) {
  const history = useHistory();
  const [units, setUnits] = useState([]);
  const { id } = props;

  useEffect(() => {
    getPropertyUnits(id).then((data) => {
      setUnits(data);
    });
  }, [id]);

  const onClickAddUnit = () => {
    history.push(`/property/${id}/unit`);
  };

  const onClickUnit = (unitid) => {
    history.push(`/property/${id}/unit/${unitid}`);
  };

  return (
    <>
      <Paper sx={{ padding: "2rem", marginBottom: "1rem" }}>
        <Typography gutterBottom variant="h5" component="div">
          Add more units to your property
        </Typography>
        <p>Each apartment is allowed a certain flexibility</p>
        <Button variant="contained" onClick={onClickAddUnit}>
          Add unit
        </Button>
      </Paper>
      {units.map((unit, index) => (
        <Card
          sx={{
            paddingLeft: "1rem",
            paddingRight: "1rem",
            marginBottom: "1rem",
          }}
          key={index}
        >
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              Unit {unit.number}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {unit.laundry}
            </Typography>
          </CardContent>
          <Divider />
          <CardActions>
            <Button size="small" onClick={() => onClickUnit(unit.id)}>
              Edit Unit
            </Button>
            <Button
              size="small"
              component={Link}
              to={`/add-listing/${id}/unit/${unit.id}`}
            >
              List Unit
            </Button>
            <ShareDialog propertyId={id} unitId={unit.id} />
          </CardActions>
        </Card>
      ))}
    </>
  );
}

export default Units;
